module.exports = __webpack_public_path__ + "media/ROOM25sec.aef7dc73.mp4";